import React from 'react'
import moment from 'moment'
var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export function ReducedMonth(number=0) {
  return months[number-1]
}

export default class DateFormat extends React.Component {

  render() {

    if(this.props.date !== "undefined" && this.props.date !== null) {
      return <div className="text-center">{moment(this.props.date).format('DD-MM-YYYY')}</div>
    }
    else {
      return null
    }

  }
}



// WEBPACK FOOTER //
// ./src/utils/dateformat.js